const ShipmentCourierEnum = {
  FEDEX: 'FedEx',
  SHIPSMART: 'Shipsmart',
  '99MINUTOS': '99Minutos',
  LAPCOURIER: 'LAPCourier',
};

export default ShipmentCourierEnum;
